const Icon = {
  Copy: ({ size = 18, color = "#232323" }) => (
    <svg
      fill="none"
      style={{
        height: size,
        width: size,
      }}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={color}
        strokeWidth={2.0}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.75 12.75h4.5v-12h-12v4.5"
      />
      <path
        stroke={color}
        strokeWidth={2.0}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.75 5.25h-12v12h12v-12Z"
      />
    </svg>
  ),

  CopyFilled: ({ size = 18, color = "#232323" }) => (
    <svg
      fill="none"
      style={{
        height: size,
        width: size,
      }}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M14.875.5h-10a.625.625 0 0 0-.625.625V4.25H1.125a.625.625 0 0 0-.625.625v10a.625.625 0 0 0 .625.625h10a.624.624 0 0 0 .625-.625V11.75h3.125a.624.624 0 0 0 .625-.625v-10A.625.625 0 0 0 14.875.5Zm-.625 10h-2.5V4.875a.625.625 0 0 0-.625-.625H5.5v-2.5h8.75v8.75Z"
      />
    </svg>
  ),

  Wallet: ({ size = 18, color = "#232323" }) => {
    return (
      <svg
        fill="none"
        style={{
          width: size,
          height: size * (18 / 19),
        }}
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M.75 3v12a1.5 1.5 0 0 0 1.5 1.5h15a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75h-15A1.5 1.5 0 0 1 .75 3Zm0 0a1.5 1.5 0 0 1 1.5-1.5H15"
        />
        <path
          fill={color}
          d="M13.875 11.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
        />
      </svg>
    );
  },

  Download: ({ size = 18, color = "#232323" }) => {
    return (
      <svg
        fill="none"
        style={{
          width: size,
          height: size * (20 / 18),
        }}
        viewBox="0 0 18 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.4}
          d="M15.75 19H2.25a.75.75 0 0 1-.75-.75V1.75A.75.75 0 0 1 2.25 1h9l5.25 5.25v12a.75.75 0 0 1-.75.75Z"
        />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.4}
          d="M11.25 1v5.25h5.25M9 9.25v6M6.75 13 9 15.25 11.25 13"
        />
      </svg>
    );
  },

  ArrowUpRight: ({ size = 14, color = "#232323" }) => {
    return (
      <svg
        fill="none"
        style={{
          width: size,
          height: size,
        }}
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1 13 13 1M3.25 1H13v9.75"
        />
      </svg>
    );
  },

  Play: () => (
    <svg
      height="21"
      width="21"
      fill="none"
      className="stroke"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6121 9.9203L4.22016 1.11913C4.09901 1.0444 3.96011 1.00334 3.8178 1.0002C3.67548 0.997048 3.53491 1.03193 3.41057 1.10123C3.28623 1.17053 3.18263 1.27175 3.11046 1.39445C3.03829 1.51715 3.00016 1.65688 3 1.79922V19.4016C3.00016 19.5439 3.03829 19.6836 3.11046 19.8063C3.18263 19.929 3.28623 20.0302 3.41057 20.0996C3.53491 20.1689 3.67548 20.2037 3.8178 20.2006C3.96011 20.1974 4.09901 20.1564 4.22016 20.0816L18.6121 11.2805C18.7302 11.2106 18.8282 11.1111 18.8962 10.9919C18.9642 10.8726 19 10.7377 19 10.6004C19 10.4631 18.9642 10.3282 18.8962 10.2089C18.8282 10.0897 18.7302 9.99018 18.6121 9.9203V9.9203Z"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </svg>
  ),
  CaretDown: () => (
    <svg
      height="4"
      width="7"
      fill="none"
      viewBox="0 0 7 4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 0.833415L3.83317 3.16675L5.99984 0.833415"
        strokeLinecap="round"
        strokeWidth="0.8"
      />
    </svg>
  ),
  CaretLeft: () => (
    <svg
      height="20"
      width="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 1L15 10L6 19" strokeLinecap="round" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg
      height="20"
      width="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 10.3633H19" strokeLinecap="round" />
      <path
        d="M11.6362 3L18.9999 10.3636L11.6362 17.7273"
        strokeLinecap="round"
      />
    </svg>
  ),
  ArrowDouble: () => (
    <svg
      height="28"
      width="28"
      fill="none"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 10L1 14L5 18" strokeLinecap="round" />
      <path d="M23 10L27 14L23 18" strokeLinecap="round" />
      <path d="M1 14H27" strokeLinecap="round" />
    </svg>
  ),
  ArrowsLR: () => (
    <svg
      height="20"
      width="20"
      fill="none"
      className="stroke"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 11L18 15L14 19" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M2 15H18" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M6 10L2 6L6 2" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M18 6H2" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  Filter: () => (
    <svg
      height="12"
      width="12"
      fill="none"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 8.5C12 8.36739 11.9473 8.24021 11.8536 8.14645C11.7598 8.05268 11.6326 8 11.5 8H8.5C8.36739 8 8.24021 8.05268 8.14645 8.14645C8.05268 8.24021 8 8.36739 8 8.5C8 8.63261 8.05268 8.75979 8.14645 8.85355C8.24021 8.94732 8.36739 9 8.5 9H11.5C11.6326 9 11.7598 8.94732 11.8536 8.85355C11.9473 8.75979 12 8.63261 12 8.5ZM12 5.5C12 5.36739 11.9473 5.24021 11.8536 5.14645C11.7598 5.05268 11.6326 5 11.5 5H4.5C4.36739 5 4.24021 5.05268 4.14645 5.14645C4.05268 5.24021 4 5.36739 4 5.5C4 5.63261 4.05268 5.75979 4.14645 5.85355C4.24021 5.94732 4.36739 6 4.5 6H11.5C11.6326 6 11.7598 5.94732 11.8536 5.85355C11.9473 5.75979 12 5.63261 12 5.5ZM12 2.5C12 2.36739 11.9473 2.24021 11.8536 2.14645C11.7598 2.05268 11.6326 2 11.5 2H0.5C0.367392 2 0.240215 2.05268 0.146447 2.14645C0.0526785 2.24021 0 2.36739 0 2.5C0 2.63261 0.0526785 2.75979 0.146447 2.85355C0.240215 2.94732 0.367392 3 0.5 3H11.5C11.6326 3 11.7598 2.94732 11.8536 2.85355C11.9473 2.75979 12 2.63261 12 2.5Z" />
    </svg>
  ),
  Logo: () => (
    <svg
      height="40"
      width="182"
      fill="none"
      viewBox="0 0 182 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M152.44 22.56C152.44 18.68 153.64 15.88 157.16 15.88C160.68 15.88 160.96 18.72 160.96 21.64V34H165.72V22.56C165.72 18.68 166.92 15.88 170.44 15.88C173.96 15.88 174.24 18.72 174.24 21.64V34H179V20.48C179 15.36 177.04 12 171.96 12C169.32 12 166.8 13.08 164.96 15.8C163.96 13.4 162 12 158.68 12C155.8 12 153.68 13.24 152.44 15.48V12.48H147.68V34H152.44V22.56Z"
        fill="#232323"
      />
      <path
        d="M20.56 34H26.28L19.64 20.84C23.24 19.6 25.08 17.08 25.08 13.36C25.08 6.92 20.72 5 12.16 5H2.92V34H8V21.8H12.92C13.44 21.8 13.96 21.8 14.44 21.76L20.56 34ZM12.88 9.08C16.88 9.08 19.88 9.6 19.88 13.4C19.88 16.88 17.4 17.76 13.04 17.76H8V9.08H12.88ZM41.7578 25.52C41.7578 29.16 39.6778 30.96 36.1578 30.96C33.7578 30.96 32.1978 29.84 32.1978 27.96C32.1978 25.48 34.9578 24.52 41.7578 23.88V25.52ZM35.1178 34.52C38.2778 34.52 40.8378 33.4 42.1978 31.08C42.2778 32.56 42.4378 33.08 42.5978 34H46.9578C46.5578 32.2 46.3178 29.36 46.3178 26.64C46.3178 24.68 46.3978 22.16 46.3978 21.08C46.5178 14.2 42.4778 11.84 37.3178 11.84C32.1178 11.84 28.4778 14.84 28.1578 19.24H32.8378C32.9578 16.64 34.7578 15.36 37.1578 15.36C39.5178 15.36 41.6378 16.48 41.6378 20.16V20.56C33.7578 21.36 27.1578 22.72 27.1578 28.08C27.1578 32 30.4378 34.52 35.1178 34.52ZM54.9713 12.48H50.2113V34H54.9713V22.56C54.9713 18.68 56.3313 15.88 59.9713 15.88C63.6113 15.88 64.0513 18.72 64.0513 21.64V34H68.8113V20.48C68.8113 15.36 66.6913 12 61.4913 12C58.4913 12 56.2113 13.24 54.9713 15.48V12.48ZM87.0459 15.36C85.7659 13.24 83.5259 12 80.6459 12C75.5659 12 71.2859 16.36 71.2859 23.24C71.2859 30.16 75.5659 34.52 80.6459 34.52C83.5259 34.52 85.7659 33.28 87.0459 31.16V34H91.8059V5H87.0459V15.36ZM87.2459 23.24C87.2459 28.2 84.8059 30.64 81.6859 30.64C78.5259 30.64 76.2459 27.8 76.2459 23.24C76.2459 18.72 78.5259 15.88 81.6859 15.88C84.8059 15.88 87.2459 18.28 87.2459 23.24ZM120.42 34V5H115.5V28.16L103.22 5H96.42V34H101.34V10.84L113.62 34H120.42Z"
        fill="#232323"
      />
      <path
        d="M134 13L134.002 22.9902L137.827 13.7612L134.006 22.9917L141.071 15.9289L134.008 22.9944L143.239 19.1731L134.01 22.9981L144 23L134.01 23.0019L143.239 26.8269L134.008 23.0056L141.071 30.071L134.006 23.0083L137.827 32.2388L134.002 23.0098L134 33L133.998 23.0098L130.173 32.2388L133.994 23.0083L126.929 30.071L133.992 23.0056L124.761 26.8269L133.99 23.0019L124 23L133.99 22.9981L124.761 19.1731L133.992 22.9944L126.929 15.9289L133.994 22.9917L130.173 13.7612L133.998 22.9902L134 13Z"
        stroke="#232323"
      />
    </svg>
  ),

  CaretDownBold: ({ size, color = "#B8BABE" }) => (
    <svg
      style={{
        width: size,
        height: size * (4 / 7),
      }}
      fill="none"
      viewBox="0 0 7 4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 0.833415L3.83317 3.16675L5.99984 0.833415"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  ),

  Logo2: () => (
    <svg
      height="50"
      width="184"
      fill="none"
      viewBox="0 0 184 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#232323"
        d="M2.562 41H7.56V29.408h7.35c7.224 0 4.41 10.332 5.796 11.592h5.25v-.294c-1.596-.504.924-12.264-6.006-13.566v-.084c3.444-.84 5.586-3.276 5.586-7.476 0-5.46-3.99-8.61-10.164-8.61H2.562V41ZM7.56 15.212h6.762c3.066 0 6.258.63 6.258 4.956 0 4.368-3.192 4.956-6.258 4.956H7.56v-9.912Zm34.588 9.954c0 2.058-2.016 2.478-5.334 3.108-5.376 1.05-8.862 2.52-8.862 7.224 0 3.612 2.688 6.132 7.056 6.132 3.318 0 5.754-1.302 7.098-3.192h.084c.42 2.1 1.512 2.94 3.864 2.94.84 0 1.554-.084 2.562-.462v-2.1c-1.722.168-2.058-.63-2.058-2.142V26.468c0-5.712-3.528-7.518-8.274-7.518-6.468 0-9.114 3.234-9.324 7.35h4.284c.21-2.772 1.512-3.864 5.04-3.864 2.94 0 3.864 1.176 3.864 2.73Zm-6.174 12.978c-2.394 0-3.57-1.092-3.57-3.066 0-2.184 1.596-3.234 5.25-4.032 2.058-.42 3.78-.924 4.494-1.428v3.234c0 3.486-2.52 5.292-6.174 5.292ZM62.746 18.95c-3.696 0-5.922 1.68-7.056 3.36h-.084v-2.772h-4.41V41h4.41V27.938c0-3.192 2.184-5.25 5.586-5.25 3.024 0 4.242 1.848 4.242 4.746V41h4.452V26.174c0-4.914-3.15-7.224-7.14-7.224Zm26.25-7.98v11.172h-.084c-1.134-1.638-3.234-3.192-6.552-3.192-5.502 0-9.576 4.284-9.576 11.34s4.074 11.34 9.576 11.34c3.318 0 5.418-1.638 6.552-3.108h.084V41h4.41V10.97h-4.41Zm-5.88 27.048c-3.864 0-5.922-3.528-5.922-7.728 0-4.2 2.058-7.728 5.922-7.728 3.612 0 5.838 2.94 5.838 7.728 0 4.746-2.226 7.728-5.838 7.728Zm26.059-19.068c-3.696 0-5.922 1.68-7.056 3.36h-.084v-2.772h-4.41V41h4.41V27.938c0-3.192 2.184-5.25 5.586-5.25 3.024 0 4.242 1.848 4.242 4.746V41h4.452V26.174c0-4.914-3.15-7.224-7.14-7.224ZM174.788 18.95c-3.318 0-5.418 1.638-7.014 3.696h-.084c-.882-2.31-2.688-3.696-5.712-3.696-3.234 0-5.25 1.68-6.384 3.36h-.084v-2.772h-4.41V41h4.41V27.938c0-3.192 1.89-5.25 4.83-5.25 3.066 0 3.654 1.848 3.654 4.746V41h4.452V27.938c0-3.192 1.848-5.25 4.83-5.25 3.024 0 3.612 1.848 3.612 4.746V41h4.452V26.174c0-4.62-2.226-7.224-6.552-7.224ZM120.324 28.472c-.548-.747-.395-1.356.414-1.614 1.578-.505 3.219-.683 4.861-.835.903-.084 1.81-.144 2.714-.24a46.563 46.563 0 0 1-6.7-.965c-1.265-.277-1.586-.64-1.587-1.935 0-.233-.011-.467.004-.699a1.232 1.232 0 0 1 1.152-1.177c.135-.011.271-.006.407-.006h23.696c1.279 0 1.708.425 1.715 1.705.008 1.468-.243 1.788-1.673 2.114a42.128 42.128 0 0 1-6.946.964c1.912.133 3.823.269 5.717.58.727.12 1.443.284 2.152.486.464.131.744.38.741.898-.002.511-.27.762-.736.904-1.473.45-2.992.644-4.512.807-3.69.397-7.396.423-11.1.34-3.041-.069-6.077-.272-9.063-.916-.418-.09-.831-.194-1.256-.41ZM146.096 31.393c.221.5-.144.622-.438.744-1.012.422-2.094.565-3.169.692-3.548.42-7.112.553-10.682.475-3.119-.069-6.238-.199-9.311-.813a8.1 8.1 0 0 1-1.113-.328c-.271-.096-.606-.208-.603-.548.002-.344.356-.439.617-.539.874-.334 1.794-.494 2.716-.617 4.398-.586 8.821-.567 13.241-.444 2.457.068 4.917.228 7.328.78.489.112.988.216 1.414.598ZM137.054 33.853c2.045.142 4.042.185 6.009.556.342.064.683.142 1.017.238.237.067.549.125.56.424.011.307-.303.37-.537.445-.834.269-1.701.373-2.566.471-3.823.435-7.663.43-11.499.319-2.259-.066-4.531-.158-6.749-.68-.359-.085-.927-.086-.936-.527-.01-.444.561-.461.912-.55 1.547-.396 3.139-.474 4.721-.587 3.001-.214 6.008-.151 9.068-.109ZM131.951 39.013c-2.305-.161-4.593 0-6.806-.73.142-.426.417-.437.65-.495 1.42-.352 2.88-.416 4.327-.447 2.868-.062 5.74-.12 8.606.104.829.065 1.66.14 2.473.339.222.054.459.089.609.331-.129.359-.479.352-.758.416-.984.227-1.992.296-2.996.352-2.014.112-4.03.175-6.105.13ZM135.861 40.395c.579.133 1.176-.022 1.667.378-.945.654-7.141.655-8.209-.078 2.236-.526 4.368-.332 6.542-.3Z"
      />
    </svg>
  ),

  Dawn: () => (
    <svg
      height="30"
      width="30"
      fill="none"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 0L15.0029 14.9852L20.7403 1.1418L15.0083 14.9875L25.6066 4.3934L15.0125 14.9917L28.8582 9.25972L15.0148 14.9971L30 15L15.0148 15.0029L28.8582 20.7403L15.0125 15.0083L25.6066 25.6066L15.0083 15.0125L20.7403 28.8582L15.0029 15.0148L15 30L14.9971 15.0148L9.25972 28.8582L14.9917 15.0125L4.3934 25.6066L14.9875 15.0083L1.1418 20.7403L14.9852 15.0029L0 15L14.9852 14.9971L1.1418 9.25972L14.9875 14.9917L4.3934 4.3934L14.9917 14.9875L9.25972 1.1418L14.9971 14.9852L15 0Z" />
    </svg>
  ),
  SoftStar: () => (
    <svg
      height="30"
      width="30"
      fill="none"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.5997 0.355592C14.656 -0.118531 15.344 -0.118531 15.4003 0.355592L15.8722 4.33305C16.4816 9.46903 20.531 13.5184 25.6669 14.1278L29.6444 14.5997C30.1185 14.656 30.1185 15.344 29.6444 15.4003L25.6669 15.8722C20.531 16.4816 16.4816 20.531 15.8722 25.6669L15.4003 29.6444C15.344 30.1185 14.656 30.1185 14.5997 29.6444L14.1278 25.6669C13.5184 20.531 9.46903 16.4816 4.33305 15.8722L0.355592 15.4003C-0.118531 15.344 -0.118531 14.656 0.355592 14.5997L4.33305 14.1278C9.46903 13.5184 13.5184 9.46903 14.1278 4.33305L14.5997 0.355592Z" />
    </svg>
  ),
  Scroll: () => (
    <svg
      height="32"
      width="32"
      fill="none"
      className="stroke"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 22V8.00003C25.0017 7.6056 24.9252 7.21475 24.775 6.85002C24.6248 6.4853 24.4039 6.15392 24.125 5.87502C23.8461 5.59611 23.5147 5.3752 23.15 5.22502C22.7853 5.07484 22.3944 4.99837 22 5.00003H5"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
      <path d="M13 13H21" strokeLinecap="round" strokeWidth="1.8" />
      <path d="M13 17H21" strokeLinecap="round" strokeWidth="1.8" />
      <path
        d="M2.7625 10.0004C2.43867 9.63778 2.20781 9.20194 2.08977 8.73036C1.97174 8.25877 1.97007 7.76557 2.08492 7.2932C2.19977 6.82083 2.42769 6.38345 2.74907 6.0187C3.07044 5.65395 3.47564 5.37276 3.92979 5.19934C4.38394 5.02592 4.87342 4.96546 5.35612 5.02317C5.83881 5.08087 6.30025 5.25501 6.70072 5.53061C7.10118 5.8062 7.42868 6.17498 7.65501 6.60521C7.88135 7.03543 7.99974 7.51422 8 8.00035V24.0004C8.00026 24.4865 8.11865 24.9653 8.34499 25.3955C8.57132 25.8257 8.89882 26.1945 9.29928 26.4701C9.69975 26.7457 10.1612 26.9198 10.6439 26.9775C11.1266 27.0352 11.6161 26.9748 12.0702 26.8014C12.5244 26.6279 12.9296 26.3468 13.2509 25.982C13.5723 25.6173 13.8002 25.1799 13.9151 24.7075C14.0299 24.2351 14.0283 23.7419 13.9102 23.2703C13.7922 22.7988 13.5613 22.3629 13.2375 22.0004H27.2375C27.6237 22.4321 27.8766 22.9664 27.9657 23.5388C28.0548 24.1111 27.9764 24.697 27.7398 25.2257C27.5031 25.7545 27.1185 26.2034 26.6324 26.5183C26.1462 26.8332 25.5792 27.0006 25 27.0004H11"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
    </svg>
  ),
  Strategy: () => (
    <svg
      height="32"
      width="32"
      fill="none"
      className="stroke"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 27C10.433 27 12 25.433 12 23.5C12 21.567 10.433 20 8.5 20C6.567 20 5 21.567 5 23.5C5 25.433 6.567 27 8.5 27Z"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path d="M5 9L10 14" strokeLinecap="round" strokeWidth="2" />
      <path d="M10 9L5 14" strokeLinecap="round" strokeWidth="2" />
      <path d="M22 21L27 26" strokeLinecap="round" strokeWidth="2" />
      <path d="M27 21L22 26" strokeLinecap="round" strokeWidth="2" />
      <path d="M17 10V5H22" strokeLinecap="round" strokeWidth="2" />
      <path
        d="M17 5L19 7C24 12 20 18 16 19"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  ),
  Dice: () => (
    <svg
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 5H8C6.34315 5 5 6.34315 5 8V24C5 25.6569 6.34315 27 8 27H24C25.6569 27 27 25.6569 27 24V8C27 6.34315 25.6569 5 24 5Z"
        strokeLinecap="round"
        strokeWidth="1.8"
        className="stroke"
      />
      <path
        d="M11.5 13C12.3284 13 13 12.3284 13 11.5C13 10.6716 12.3284 10 11.5 10C10.6716 10 10 10.6716 10 11.5C10 12.3284 10.6716 13 11.5 13Z"
        className="fill"
      />
      <path
        d="M20.5 13C21.3284 13 22 12.3284 22 11.5C22 10.6716 21.3284 10 20.5 10C19.6716 10 19 10.6716 19 11.5C19 12.3284 19.6716 13 20.5 13Z"
        className="fill"
      />
      <path
        d="M11.5 22C12.3284 22 13 21.3284 13 20.5C13 19.6716 12.3284 19 11.5 19C10.6716 19 10 19.6716 10 20.5C10 21.3284 10.6716 22 11.5 22Z"
        className="fill"
      />
      <path
        d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
        className="fill"
      />
      <path
        d="M20.5 22C21.3284 22 22 21.3284 22 20.5C22 19.6716 21.3284 19 20.5 19C19.6716 19 19 19.6716 19 20.5C19 21.3284 19.6716 22 20.5 22Z"
        className="fill"
      />
    </svg>
  ),
  Search: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.58342 18.1253C4.87508 18.1253 1.04175 14.292 1.04175 9.58366C1.04175 4.87533 4.87508 1.04199 9.58342 1.04199C14.2917 1.04199 18.1251 4.87533 18.1251 9.58366C18.1251 14.292 14.2917 18.1253 9.58342 18.1253ZM9.58342 2.29199C5.55841 2.29199 2.29175 5.56699 2.29175 9.58366C2.29175 13.6003 5.55841 16.8753 9.58342 16.8753C13.6084 16.8753 16.8751 13.6003 16.8751 9.58366C16.8751 5.56699 13.6084 2.29199 9.58342 2.29199Z" />
      <path d="M18.3333 18.9585C18.175 18.9585 18.0166 18.9002 17.8916 18.7752L16.225 17.1085C15.9833 16.8669 15.9833 16.4669 16.225 16.2252C16.4666 15.9835 16.8666 15.9835 17.1083 16.2252L18.775 17.8919C19.0166 18.1335 19.0166 18.5335 18.775 18.7752C18.65 18.9002 18.4916 18.9585 18.3333 18.9585Z" />
    </svg>
  ),
  Close: () => (
    <svg
      height="10"
      width="10"
      fill="none"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.757324 0.757324L9.24261 9.24261"
        strokeLinecap="round"
        strokeWidth="1.3"
      />
      <path
        d="M0.757324 9.24261L9.24261 0.757324"
        strokeLinecap="round"
        strokeWidth="1.3"
      />
    </svg>
  ),
  Checked: () => (
    <svg
      height="14"
      width="14"
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.00016 0.333008C3.32683 0.333008 0.333496 3.32634 0.333496 6.99967C0.333496 10.673 3.32683 13.6663 7.00016 13.6663C10.6735 13.6663 13.6668 10.673 13.6668 6.99967C13.6668 3.32634 10.6735 0.333008 7.00016 0.333008ZM10.1868 5.46634L6.40683 9.24634C6.3135 9.33967 6.18683 9.39301 6.0535 9.39301C5.92016 9.39301 5.7935 9.33967 5.70016 9.24634L3.8135 7.35967C3.62016 7.16634 3.62016 6.84634 3.8135 6.65301C4.00683 6.45967 4.32683 6.45967 4.52016 6.65301L6.0535 8.18634L9.48016 4.75967C9.6735 4.56634 9.9935 4.56634 10.1868 4.75967C10.3802 4.95301 10.3802 5.26634 10.1868 5.46634Z" />
    </svg>
  ),

  // ASSETS
  Algo: ({ size = 30 }) => (
    <svg
      fill="none"
      // style={{
      //   height: size * (31 / 30),
      //   width: size,
      // }}
      viewBox="0 0 30 31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M30 30.0403H25.2966L22.242 18.6776L15.6746 30.0415H10.4237L20.5743 12.4513L18.9407 6.34461L5.2534 30.0453H0L17.346 0H21.945L23.9587 7.46476H28.7036L25.464 13.0983L30 30.0403Z" />
    </svg>
  ),
  AlgoRound: ({ size = 16 }) => (
    <svg
      fill="none"
      style={{
        height: size,
        width: size,
      }}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_435_2)">
        <path
          d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
          fill="#232323"
        />
        <path
          d="M24.4731 24.4985H21.5073L19.5811 17.3334L15.4398 24.4993H12.1287L18.5295 13.4073L17.4993 9.55646L8.86836 24.5017H5.55566L16.4938 5.55566H19.3938L20.6636 10.2628H23.6557L21.6128 13.8152L24.4731 24.4985Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_435_2">
          <rect height="30" width="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  // WALLET CONNET PLATFORMS
  pera: () => (
    <svg
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="32" width="32" fill="#FFEE55" rx="6" />
      <path
        d="M17.3297 8.29222C17.8074 10.2716 17.6459 12.0128 16.9689 12.1812C16.292 12.3496 15.3559 10.8815 14.8781 8.9021C14.4004 6.92271 14.5619 5.18157 15.2389 5.01316C15.9158 4.84474 16.8519 6.31283 17.3297 8.29222Z"
        fill="#1C1C1C"
      />
      <path
        d="M25.2186 9.99397C24.1606 8.87261 22.0556 9.17655 20.5171 10.6728C18.9785 12.1691 18.5889 14.2911 19.647 15.4125C20.705 16.5338 22.8099 16.2299 24.3485 14.7336C25.8871 13.2374 26.2766 11.1153 25.2186 9.99397Z"
        fill="#1C1C1C"
      />
      <path
        d="M16.8035 27.1648C17.4805 26.9963 17.6182 25.1567 17.1111 23.0558C16.604 20.9549 15.6442 19.3883 14.9672 19.5567C14.2902 19.7251 14.1525 21.5648 14.6596 23.6657C15.1667 25.7666 16.1265 27.3332 16.8035 27.1648Z"
        fill="#1C1C1C"
      />
      <path
        d="M9.90257 11.0206C11.8557 11.5966 13.2828 12.607 13.0901 13.2775C12.8975 13.948 11.1581 14.0246 9.20499 13.4486C7.25191 12.8727 5.82479 11.8622 6.01742 11.1917C6.21005 10.5213 7.9495 10.4446 9.90257 11.0206Z"
        fill="#1C1C1C"
      />
      <path
        d="M22.5789 18.5917C24.6518 19.203 26.1761 20.2421 25.9835 20.9126C25.7909 21.5831 23.9542 21.631 21.8813 21.0197C19.8083 20.4084 18.284 19.3693 18.4766 18.6988C18.6693 18.0284 20.5059 17.9804 22.5789 18.5917Z"
        fill="#1C1C1C"
      />
      <path
        d="M12.1001 17.1849C11.6158 16.6829 10.0272 17.4136 8.55185 18.817C7.07651 20.2205 6.27315 21.7652 6.75748 22.2672C7.24182 22.7693 8.83045 22.0386 10.3058 20.6352C11.7811 19.2317 12.5845 17.687 12.1001 17.1849Z"
        fill="#1C1C1C"
      />
    </svg>
  ),
  myAlgo: () => (
    <svg
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9766 31.9999C12.8169 32.0002 9.72809 31.0635 7.10077 29.3082C4.47345 27.553 2.42565 25.058 1.21634 22.1389C0.00703526 19.2197 -0.309462 16.0076 0.306877 12.9085C0.923216 9.80953 2.44471 6.96289 4.67894 4.72862C6.16001 3.23452 7.92161 2.04767 9.8626 1.2362C11.8036 0.424739 13.8857 0.00464508 15.9895 3.83043e-05C18.0933 -0.00456847 20.1773 0.406403 22.1218 1.20936C24.0663 2.01231 25.8331 3.19144 27.3207 4.67904C28.8083 6.16664 29.9874 7.93342 30.7904 9.87794C31.5933 11.8225 32.0043 13.9064 31.9997 16.0102C31.9951 18.114 31.575 20.1962 30.7635 22.1371C29.9521 24.0781 28.7652 25.8397 27.2711 27.3208C25.7914 28.8087 24.0312 29.9884 22.0925 30.7916C20.1538 31.5948 18.0751 32.0055 15.9766 31.9999ZM20.226 11.2241L20.3554 11.7226L22.9746 21.2167H25.1057L21.5304 8.90455L21.4434 8.56986H19.5846L19.5415 8.63696L17.8026 11.725L16.0198 14.8921L15.9766 14.9679L15.9567 14.8921L15.737 14.0781L15.1283 11.725L15.0628 11.4909L14.3887 8.90375L14.3016 8.56907H12.4461L12.403 8.63616L10.6649 11.725L8.88202 14.8921L7.11037 18.048L5.32753 21.2167H7.45703L9.23987 18.0496L11.0227 14.8945L12.7944 11.7274L13.0875 11.2257L13.2177 11.7274L13.7609 13.8129L14.4358 16.4105L14.6706 17.2963L14.2473 18.0496L12.4621 21.2167H14.5916L15.344 19.8803L16.6516 17.5599L18.1572 14.8945L19.9289 11.7274L20.2212 11.2281L20.226 11.2241Z"
        fill="#245EC6"
      />
    </svg>
  ),
};

export default Icon;
